module.exports = __webpack_public_path__ + "static/benefits-img9-aa63ae9f71db39e5c963c777294b978f.png";